module.exports = __webpack_public_path__ + "img/vertical_7_6_9006.29bd325e.png";